import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React from "react";

const TableIngredients = ({
  ingredients,
  removeIngredient,
}: {
  ingredients: {
    id: string;
    name: string;
    quantity_needed: number;
  }[];
  removeIngredient(id: string): void;
}) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Nombre</TableCell>
            <TableCell>Cantidad</TableCell>
            <TableCell>Acción</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {ingredients.map(
            ({ id, name, quantity_needed }: any, index: number) => (
              <TableRow key={index}>
                <TableCell>{name}</TableCell>
                <TableCell>{quantity_needed}</TableCell>
                <TableCell>
                  <Tooltip title="Eliminar">
                    <IconButton
                      color="error"
                      onClick={() => removeIngredient(id)}
                    >
                      <span className="material-symbols-rounded">delete</span>
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableIngredients;
